// extracted by mini-css-extract-plugin
export default {"nav":"AuthorizedMenu_nav__k0CqL","notificationBadge":"AuthorizedMenu_notificationBadge__Y6Eyk"};